module.exports = __webpack_public_path__ + "img/enemy-kills.578c830b.png";